import { atom } from "jotai";

export const aiBotUpgradeModalOpenAtom = atom(false); 